export const FETCH_PARDOT_FIELDS_SUCCESS = 'FETCH_PARDOT_FIELDS_SUCCESS'
export const FETCH_PARDOT_MAPPINGS_SUCCESS = 'FETCH_PARDOT_MAPPINGS_SUCCESS'
export const PATCH_PARDOT_MAPPINGS_ERROR = 'PATCH_PARDOT_MAPPINGS_ERROR'
export const PATCH_PARDOT_MAPPINGS_SUCCESS = 'PATCH_PARDOT_MAPPINGS_SUCCESS'
export const PATCH_PARDOT_MAPPINGS_START = 'PATCH_PARDOT_MAPPINGS_START' 


// WEBPACK FOOTER //
// ./src/scripts/app/modules/pardot/constants.js